import { LoginPage } from "./LoginPage";

/**
 * «Всё видно»: there is no self sign-up. The first owner is created with the
 * crm-api CLI (create-owner), other users by the owner, so the start page is
 * always the email + password login.
 */
export const StartPage = () => <LoginPage />;
